import { useState, useMemo, useCallback } from 'react';
import { transformToFlowData } from './flowchartUtils';
import { BaseFlowchart } from './BaseFlowchart';
import { ActionDetailPanel } from './ActionDetailPanel';

const LEGEND_ITEMS = [
  { type: 'value', label: 'Values' },
  { type: 'competency', label: 'Competencies' },
  { type: 'action', label: 'Actions' },
  { type: 'shared', label: 'Shared Actions' },
];

export function FlowchartView({ values, direction = 'LR' }) {
  const [selectedAction, setSelectedAction] = useState(null);

  // Transform data with memoization
  const { nodes, edges } = useMemo(() => {
    if (!values || values.length === 0) {
      return { nodes: [], edges: [] };
    }
    return transformToFlowData(values, direction);
  }, [values, direction]);

  // Handle node click
  const handleNodeClick = useCallback((event, node) => {
    if (node.type === 'actionNode') {
      setSelectedAction(node.data);
    }
  }, []);

  // Close detail panel
  const handleClosePanel = useCallback(() => {
    setSelectedAction(null);
  }, []);

  if (!values || values.length === 0) {
    return (
      <div className="flowchart-empty">
        <p>No data available to display flowchart.</p>
      </div>
    );
  }

  return (
    <>
      <BaseFlowchart
        nodes={nodes}
        edges={edges}
        direction={direction}
        onNodeClick={handleNodeClick}
        legendItems={LEGEND_ITEMS}
        fitViewOptions={{ minZoom: 0.1 }}
      />
      <ActionDetailPanel
        action={selectedAction}
        onClose={handleClosePanel}
      />
    </>
  );
}
